/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      // let menuOpen = false;
      // $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
      //   menuOpen = !menuOpen;
      //   if ( menuOpen ) {
      //     setTimeout( function() {
      //       $( '.primary-nav-wrapper' ).focus();
      //     }, 500 );
      //   }
      // } );

      // let dropdownOpen = false;
      // $( '.navbar .dropdown-toggle' ).on( 'toggleAfter', ( event ) => {
      //   dropdownOpen = !dropdownOpen;
      //   if ( dropdownOpen ) {
      //     setTimeout( function() {
      //       $( $( event.target ).attr( 'data-toggle-main-target' ) ).focus();
      //     }, 500 );
      //   }
      // } );

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        setTimeout( function() {
          $( '.dropdown-toggle[data-key="0"]' ).trigger( 'click' );
        }, 1500 );
      } );

      window.navHeight = $( '.navbar' ).outerHeight();

      if ( $( 'body' ).hasClass( 'admin-bar' ) ) {
        window.navHeight += $( '#wpadminbar' ).outerHeight();
      }

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '.js-init-inline' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      } );

      $( '.js-init-image' ).magnificPopup( {
        type: 'image',
        mainClass: 'mfp-fade mfp-image-popup',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );


      // Move label by default if a value is already present
      $( '.gform_wrapper .ll_has_placeholder_label .ginput_container > *:first-child' ).each( function() {
        if ( $( this ).val().length > 0 ) {
          $( this ).closest( '.gfield' ).addClass( 'is-focused' );
        }
      } );

      // Move label up on focus
      $( document ).on( 'focus', '.gform_wrapper .ll_has_placeholder_label .ginput_container > *:first-child', function() {
        $( this ).closest( '.gfield' ).addClass( 'is-focused' );
      } );

      // Move label back down on blur, unless it has a value
      $( document ).on( 'blur', '.gform_wrapper .ll_has_placeholder_label .ginput_container > *:first-child', function() {
        if ( $( this ).val().length === 0 ) {
          $( this ).closest( '.gfield' ).removeClass( 'is-focused' );
        }
      } );

      // Move label up if there are validation errors
      $( document ).on( 'gform_post_render', function( e, formId ) {
        $( '#gform_' + formId + ' .ll_has_placeholder_label .ginput_container > *:first-child' ).each( function() {
          if ( $( this ).val().length > 0 ) {
            $( this ).closest( '.gfield' ).addClass( 'is-focused' );
          }
        } );
      } );

      if ( $( '.gform_wrapper' ).length > 0 && typeof ( gform ) !== 'undefined' ) {
        gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
          if ( $( '#input_' + formId + '_' + fieldId ).val() ) {
            const path = $( '#input_' + formId + '_' + fieldId ).val().replace( 'C:\\fakepath\\', '' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( path );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).addClass( 'has-file' );
          } else {
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( 'No file selected' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).removeClass( 'has-file' );
          }
        }, 10, 3 );
      }

      if ( !localStorage.getItem( 'scitonAcceptedCookies' ) ) {
        $( '.cookies-popup' ).addClass( 'is-visible' );
      }

      $( '.cookies-popup button.accept' ).on( 'click', function() {
        $( '.cookies-popup' ).removeClass( 'is-visible' );
        localStorage.setItem( 'scitonAcceptedCookies', 'true' );
      } );

      $( 'body :not(script, sup)' ).contents().filter( function() {
        return this.nodeType === 3;
      } ).replaceWith( function() {
        return this.nodeValue.replace( /[®©™]/g, '<sup>$&</sup>' );
      } );

      if ( $( 'body' ).hasClass( 'll_bag-template-default' ) ) {
        if ( $( '.bag_single-gallery_slick-nav .bag_gallery-image' ).length > 1 ) {
          $( '.bag_single-gallery_slick-nav' ).addClass( 'has-multiple-images' );
        }
      }

      $( '.mec-calendar-metabox a' ).each( function() {
        if ( this.host !== window.location.host ) {
          $( this ).attr( 'target', '_blank' );
        }
      } );

      // italicize it in BAREit
      $( 'body :not(script, sup)' ).contents().filter( function() {
        return this.nodeType === 3;
      } ).replaceWith( function() {
        return this.nodeValue.replace( /\bBAREit\b/i, 'BARE<i>it</i>' );
      } );

      const getUrlParameter = function getUrlParameter( sParam ) {
        const sPageURL = window.location.search.substring( 1 );
        const sURLVariables = sPageURL.split( '&' );
        let sParameterName;
        let i;

        for ( i = 0; i < sURLVariables.length; i++ ) {
          sParameterName = sURLVariables[i].split( '=' );

          if ( sParameterName[0] === sParam ) {
            return sParameterName[1] === undefined ? true : decodeURIComponent( sParameterName[1] );
          }
        }
        return false;
      };

      function filterEvents() {
        let hasFilters = false;
        if ( getUrlParameter( 'event-category' ) ) {
          $( '#mec_sf_category_1209' ).val( getUrlParameter( 'event-category' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-location' ) ) {
          $( '#mec_sf_location_1209' ).val( getUrlParameter( 'event-location' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-organizer' ) ) {
          $( '#mec_sf_organizer_1209' ).val( getUrlParameter( 'event-organizer' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-tag' ) ) {
          $( '#mec_sf_tag_1209' ).val( getUrlParameter( 'event-tag' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-label' ) ) {
          $( '#mec_sf_label_1209' ).val( getUrlParameter( 'event-label' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-address' ) ) {
          $( '#mec_sf_address_s_1209' ).val( getUrlParameter( 'event-address' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-cost-min' ) ) {
          $( '#mec_sf_event_cost_min_1209' ).val( getUrlParameter( 'event-cost-min' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-cost-max' ) ) {
          $( '#mec_sf_event_cost_max_1209' ).val( getUrlParameter( 'event-cost-max' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-month' ) ) {
          $( '#mec_sf_month_1209' ).val( getUrlParameter( 'event-month' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-year' ) ) {
          $( '#mec_sf_year_1209' ).val( getUrlParameter( 'event-year' ) );
          hasFilters = true;
        }

        if ( getUrlParameter( 'event-search' ) ) {
          $( '#mec_sf_s_1209' ).val( getUrlParameter( 'event-search' ) );
          hasFilters = true;
        }

        if ( hasFilters ) {
          setTimeout( function() {
            $( '#mec_sf_category_1209' ).trigger( 'change' );
          }, 500 );
        }
      }

      filterEvents();

      $( document ).on( 'change', '#mec_search_form_1209 input, #mec_search_form_1209 select', function() {
        const filters = {};

        if ( $( '#mec_sf_category_1209' ).val() ) {
          filters['event-category'] = $( '#mec_sf_category_1209' ).val();
        }

        if ( $( '#mec_sf_location_1209' ).val() ) {
          filters['event-location'] = $( '#mec_sf_location_1209' ).val();
        }

        if ( $( '#mec_sf_organizer_1209' ).val() ) {
          filters['event-organizer'] = $( '#mec_sf_organizer_1209' ).val();
        }

        if ( $( '#mec_sf_tag_1209' ).val() ) {
          filters['event-tag'] = $( '#mec_sf_tag_1209' ).val();
        }

        if ( $( '#mec_sf_label_1209' ).val() ) {
          filters['event-label'] = $( '#mec_sf_label_1209' ).val();
        }

        if ( $( '#mec_sf_address_s_1209' ).val() ) {
          filters['event-address'] = $( '#mec_sf_address_s_1209' ).val();
        }

        if ( $( '#mec_sf_event_cost_min_1209' ).val() ) {
          filters['event-cost-min'] = $( '#mec_sf_event_cost_min_1209' ).val();
        }

        if ( $( '#mec_sf_event_cost_max_1209' ).val() ) {
          filters['event-cost-min'] = $( '#mec_sf_event_cost_max_1209' ).val();
        }

        if ( $( '#mec_sf_month_1209' ).val() ) {
          filters['event-month'] = $( '#mec_sf_month_1209' ).val();
        }

        if ( $( '#mec_sf_year_1209' ).val() ) {
          filters['event-year'] = $( '#mec_sf_year_1209' ).val();
        }

        if ( $( '#mec_sf_s_1209' ).val() ) {
          filters['event-search'] = $( '#mec_sf_s_1209' ).val();
        }

        let params = '';
        let i = 0;
        $.each( filters, function( index, val ) {
          if ( i == 0 ) {
            params += '?' + index + '=' + val;
          } else {
            params += '&' + index + '=' + val;
          }
          i++;
        } );

        const nextURL = window.location.href.split( '?' )[0] + params;
        const nextTitle = 'Filtered Events';
        const nextState = {additionalInformation: 'Filtered the events'};

        // This will create a new entry in the browser's history, without reloading
        window.history.pushState( nextState, nextTitle, nextURL );

        // This will replace the current entry in the browser's history, without reloading
        window.history.replaceState( nextState, nextTitle, nextURL );
      } );


      $( document ).ready( function() {
        const catSelect = $( '#mec_sf_category_1209' );
        catSelect.find( 'option[value=""]' ).text( 'Event Type' );

        const monthSelect = $( '#mec_sf_month_1209' );
        monthSelect.find( 'option[value=""]' ).remove();
        monthSelect.find( 'option[value="none"]' ).text( 'Month' );

        const yearSelect = $( '#mec_sf_year_1209' );
        yearSelect.find( 'option[value=""]' ).remove();
        yearSelect.find( 'option[value="none"]' ).text( 'Year' );

        const tagSelect = $( '#mec_sf_tag_1209' );
        // Remove options except the ones with the specified values
        const valuesToKeep = ['', '343'];
        tagSelect.find( 'option' ).not( function() {
          return $.inArray( $( this ).val(), valuesToKeep ) !== -1;
        } ).remove();
        $( '#mec_search_form_1209' ).css( 'opacity', 1 );
      } );

      $( document ).on( 'click', '.show-more-tags button', function( e ) {
        if ( !$( '.blog__sidebar-list.tags' ).hasClass( 'expanded' ) ) {
          $( '.blog__sidebar-list.tags' ).addClass( 'expanded' );
          $( this ).text( '- Show Less -' );
        } else {
          $( '.blog__sidebar-list.tags' ).removeClass( 'expanded' );
          $( this ).text( '- Show More -' );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
